//Models
import { VoucherTypeFormat } from './EnumEntity';
import { channels, subChannels } from './Channels'
import { utils } from '../utils/utils';

export const title = 'Listado de notas de crédito'

export const columns = [
    {
        field: 'type',
        header: 'Tipo',
        translate: (type) => VoucherTypeFormat[type]
    },
    {
        field: 'invoice',
        header: 'Cod. comprobante',
        translate: (invoice) => `${utils.zeroPad(invoice.billingCode, 5)}-${utils.zeroPad(invoice.number, 8)}`,
    },
    {
        field: 'voucher',
        header: 'Canal',
        translate: (voucher) => `${channels.labels[voucher.source]} | ${subChannels.labels[voucher.subchannel]}`
    },
    {
        field: 'seller',
        header: 'Vendedor',
        translate: (seller) => seller.code,
        tooltip: (invoice) => invoice.seller.userName,
        sizes: { xs: 1 }
    },
    {
        field: 'customer',
        header: 'Cliente',
        translate: (customer) => customer?.lastName
            ? `${customer?.firstName} ${customer?.lastName}`
            : customer?.firstName,
    },
    {
        field: 'amount',
        header: 'Importe',
        type: 'money',
        sizes: { xs: 1 }
    },
    {
        field: 'created',
        header: 'Creado',
        type: 'date',
        sizes: { xs: 2 }
    }
]

export const itemHeaders = [
    'SKU',
    'Descripción',
    'Cantidad',
    'Precio Unidad',
    'Importe'
]

export const itemKeyColumns = [
    'code',
    'name',
    'quantity',
    'priceToShow',
    'amountToShow'
]